import { useArticleStore } from "features/article/store";
import { useMutateBookmark, useMutateRead, useMutateRefundGift, useQueryBookmarked } from "features/article/data";

export const useArticle = () => {
	const mutation = useMutateBookmark();
	const read = useMutateRead();
	const store = useArticleStore();
	const toggleBookmark = (contentId, value) => mutation.mutate({ contentId, value });

	const unlock = (id) => {
		if (!store.disabled) {
			read.mutate(id);
			store.setDisabled(true);
		};
	};

	return { store, disabled: store.disabled, toggleBookmark, unlock };
};

export const useRead = useMutateRead;

export const useBookmarked = useQueryBookmarked;

export const useRefundGift = useMutateRefundGift;